import axios from "axios";
import jsonBig from "json-bigint";
import context from "../main.js";
import { Toast } from "vant";

const service = axios.create({
  baseURL:
    window.location.host == "www.credisol.pe"
      ? "https://api.credisol.pe/h5"
      : "https://gatdata-test-pe.jinglewill.com/h5",
  // timeout: 900000,
  transformResponse: [
    function(data) {
      try {
        // 如果转换成功则返回转换的数据结果
        return jsonBig.parse(data);
      } catch (err) {
        // 如果转换失败，则包装为统一数据格式并返回
        return {
          data,
        };
      }
    },
  ],
});

//http request 拦截器
service.interceptors.request.use(
  (config) => {
    if (config.type == "upload") {
      config.headers = {
        "Content-Type": "multipart/form-data",
        source: "CrediSol",
      };
    } else {
      config.data = JSON.stringify({
        ...config.data,
        access_token: localStorage.getItem("token") || "",
      });
      config.headers = {
        "Content-Type": "application/json",
        source: "CrediSol",
      };
    }
    return config;
  },
  (error) => {
    return error;
  }
);

service.interceptors.response.use((response) => {
  if (response.data.code == 400114) {
    localStorage.clear();
    Toast("El inicio de sesión ha caducado");
    context.$router.push("/h5Page/home");
    window.location.reload();
  }
  if (response.data.code == 100000) {
    Toast(response.data.message);
  }
  return response;
});

export default service;
